module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1504-e61e83cc7730428d3dc1665b1d67160c.png";